<i18n src="@/locales/components/views/customer/query/basic_containers/show_container/exportation_files.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exportation_attachment.yml" lang="yaml"></i18n>
<template>
  <div class="my-8" v-if="exportation_attachments.length > 0">
    <div class="panel-header-title">{{ $t("labels.title") }}</div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <th scope="col" class="table-header-cell">
                  {{
                    $t(
                      "model.exportation_attachment.exporter_process_exportation_file_id"
                    )
                  }}
                </th>
                <th scope="col" class="table-header-cell">
                  {{
                    $t("model.exportation_attachment.exportation_attach_name")
                  }}
                </th>
                <th scope="col" class="table-header-cell"></th>
              </thead>
              <tbody class="table-body">
                <template
                  v-for="exportation_file in exportation_files"
                  :key="exportation_file.id"
                >
                  <!-- <tr class="table-row">

                  </tr> -->
                  <!-- <tr
                    v-if="
                      exportationAttachments(exportation_file.id).length == 0
                    "
                    class="table-row"
                  >
                    <td class="table-cell">
                      {{ $t("labels.no_attachments") }}
                    </td>
                  </tr> -->
                  <tr
                    class="table-row"
                    v-for="attach in exportationAttachments(
                      exportation_file.id
                    )"
                    :key="attach.id"
                  >
                    <td class="table-cell">
                      <div class="flex justify-between">
                        <h3 class="flex items-center">
                          {{ exportation_file.name }}
                        </h3>
                      </div>
                    </td>
                    <td class="table-cell">
                      {{ attach.exportation_attach.blob.filename }}
                    </td>
                    <td class="table-cell-action">
                      <button
                        class="btn-white inline-flex"
                        @click.prevent="downloadExportationAttachment(attach)"
                      >
                        <i
                          :class="[
                            'fa-solid  ',
                            attach.downloading ? ' fa-sync fa-spin' : ' fa-download',
                          ]"
                        ></i>
                      </button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/customer/requesters/query/basic_containers/show_container.js";
export default {
  props: {
    customer_id: {
      required: true
    },
    container: {
      type: Object,
      required: true,
    },
  },
  computed: {
    exportation_files: function () {
      if (this.container)
        return this.container.agro_exporter_process
          .exporter_process_exportation_files;
      return [];
    },
    exportation_attachments: function () {
      if (this.container)
        return this.container.exportation?.exportation_attachments ?? [];
      return [];
    },
  },
  data: function () {
    return {};
  },
  methods: {
    downloadExportationAttachment: async function (exportation_attachment) {
      if (exportation_attachment.downloading) return;
      exportation_attachment.downloading = true;
      try {
        var response = await Requester.downloadExportationAttachment(
          this.customer_id,
          exportation_attachment.id
        );
        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute(
          "download",
          exportation_attachment.exportation_attach.blob.filename
        );
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      exportation_attachment.downloading = false;
    },
    exportationAttachments: function (exporter_process_exportation_file_id) {
      return this.exportation_attachments.filter(
        (exportation_attachment) =>
          exportation_attachment.exporter_process_exportation_file_id ===
          exporter_process_exportation_file_id
      );
    },
  },
};
</script>

<style>
</style>
